/* @flow */
import FeatureFlags from "../../FeatureFlags";
import type { Action } from "../action";
import type { StockID, Deal } from "../CommonTypes";

export type State = Array<Deal>;
export type TradingHistory = {
  open: Array<Deal>,
  closed: Array<Deal>
};

function receiveTradingHistory(tradingHistory?: TradingHistory) {
  if (typeof tradingHistory !== "object") {
    throw new TypeError("Deals must be an object");
  }

  return [...tradingHistory.open, ...tradingHistory.closed];
}

function receiveSocketMessage(state, message) {
  if (message.op === "operationOpened") {
    const lookupId = message.id;
    if (state.some(deal => deal.id === lookupId)) {
      // Существует рейс кондишн, при котором возможно,
      // что об открытой сделке мы знаем до того, как
      // об этом нам сообщит сокет!
      // Чтобы не было дубликатов, первым делом проверяем
      // отсутствие сделки с таким айди.
      return state;
    }

    const nextDeal = {
      id: message.id,
      stock: message.stock,
      amount: message.bidAmnt,
      bTime: message.bidTime,
      time: message.bidTime,
      bidType: message.isBidUp,
      percent: message.profitPercent,
      // profit?: number,
      timestamp: Math.floor(message.openTimestamp / 1000),
      open_timestamp: Math.floor(message.openTimestamp / 1000),
      value: message.bidValue,
      accountType: message.real === 1 ? "real" : "demo"
    };

    return [...state, nextDeal];
  }

  if (message.op === "operationClosed") {
    // По сообщению о закрытии попробуем найти у нас такую операцию
    // и руками превратить её в "закрытую". "Закрытые" отличаются
    // отсутствием поля time и наличием поля profit.
    const { id, profit } = message;

    return state.map(
      deal =>
        deal.id === id
          ? {
              ...deal,
              time: null,
              profit: profit
            }
          : deal
    );
  }

  return state;
}

function deals(state: State = [], action: Action): State {
  switch (action.type) {
    case "REQUEST_DEAL_OPENING":
      return FeatureFlags.enableOptimisticDeals
        ? [...state, action.payload]
        : state;
    case "RECEIVE_DEAL_HISTORY":
      return receiveTradingHistory(action.payload);
    case "RECEIVE_SOCKET_MESSAGE":
      return receiveSocketMessage(state, action.payload);
    case "RECEIVE_DEAL_OPENING_SUCCESS":
    case "RECEIVE_DEAL_OPENING_FAILURE":
    default:
      return state;
  }
}

export default deals;

export function getActiveDeals(
  stock: StockID,
  time: number,
  state: State
): Array<Deal> {
  return state.filter(
    deal =>
      Boolean(deal) &&
      deal.stock === stock &&
      deal.time !== undefined &&
      deal.timestamp * 1000 <= time &&
      time - deal.timestamp * 1000 < deal.bTime * 1000
  );
}



// WEBPACK FOOTER //
// ./src/redux/reducer/deals.js